import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import { ELSDivider } from "components/common/elsevier/Divider/Divider";
import { ELSSwitch } from "components/common/elsevier/Switch/Switch";
import Styles from "../Styles.module.scss";
function AllDatabasesSwitch(_ref) {
  var availableDBs = _ref.availableDBs,
    handleKeyPress = _ref.handleKeyPress,
    allDBValue = _ref.allDBValue,
    allSelected = _ref.allSelected,
    handleToggleAll = _ref.handleToggleAll,
    noDBError = _ref.noDBError;
  return /*#__PURE__*/React.createElement("div", {
    className: Styles.selectAllAvailableDBContainer
  }, availableDBs.length > 1 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: 4,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    "data-cy": "select-all-dbs-title",
    item: true,
    xs: 10,
    className: Styles.selectAllAvailableDB
  }, "Select all available databases"), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(ELSSwitch, {
    className: "es-switch--primary",
    onKeyDown: handleKeyPress,
    inputProps: _objectSpread({
      "aria-label": "Search all databases",
      "data-cy": "all-available-dbs-switch"
    }, noDBError ? {
      "aria-describedby": "no-db-error"
    } : {}),
    id: "ckb-all",
    value: allDBValue,
    checked: allSelected,
    onChange: handleToggleAll
    // labelText="All"
  })))), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    className: Styles.allDBDividerContainer
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSDivider, {
    className: "".concat(Styles.allDBDividerContainer__allDBDivider)
  }))));
}
export default AllDatabasesSwitch;